import { useState } from "react";
import {
  ArrowLeftRight,
  Award,
  Banknote,
  Bell,
  CloudUpload,
  History,
  BarChart3,
  BookOpenText,
  Boxes,
  Building2,
  Calculator,
  ChevronDown,
  ClipboardList,
  Contact,
  FileStack,
  Gauge,
  Landmark,
  LandPlot,
  LayoutDashboard,
  LayoutGrid,
  Map,
  Package,
  Percent,
  PieChart,
  Receipt,
  ReceiptText,
  Scale,
  Settings,
  Settings2,
  Shield,
  ShoppingCart,
  Tags,
  Truck,
  UserCog,
  Users,
  Wallet,
  Warehouse,
} from "lucide-react";
import { receivablesMenuGroup } from "./receivables";

export const topLevelItems = [
  { featureKey: "overview", featureName: "Overview", icon: LayoutDashboard },
  { featureKey: "alerts", featureName: "Alerts", icon: Bell },
];

export const menuGroups = [
  {
    groupKey: "masters",
    groupName: "Masters",
    icon: LayoutGrid,
    items: [
      { featureKey: "brands", featureName: "Brands", icon: Building2 },
      { featureKey: "banks", featureName: "Banks", icon: Building2 },
      { featureKey: "products", featureName: "Products", icon: Package },
      { featureKey: "taxRates", featureName: "Tax Rates", icon: Percent },
      { featureKey: "productCategories", featureName: "Product Categories", icon: Tags },
      { featureKey: "priceLists", featureName: "Price Lists", icon: Tags },
      { featureKey: "customers", featureName: "Customers", icon: Contact },
      { featureKey: "beats", featureName: "Beats", icon: Map },
      { featureKey: "salesmanBeats", featureName: "Salesman Beats", icon: UserCog },
      { featureKey: "customerBeats", featureName: "Customer Beats", icon: Contact },
      { featureKey: "firms", featureName: "Firms", icon: Landmark },
    ],
  },
  {
    groupKey: "purchases",
    groupName: "Purchases",
    icon: FileStack,
    items: [
      { featureKey: "purchaseInvoices", featureName: "Purchase Invoices", icon: ClipboardList },
      { featureKey: "purchaseDebitNotes", featureName: "Purchase Debit Notes", icon: ClipboardList },
    ],
  },
  {
    groupKey: "sales",
    groupName: "Sales",
    icon: ShoppingCart,
    items: [
      { featureKey: "salesOrders", featureName: "Sales Orders", icon: ShoppingCart, hidden: true },
      { featureKey: "salesInvoices", featureName: "Sales Invoices", icon: ReceiptText },
      { featureKey: "headerOnlyInvoices", featureName: "Import Invoices Without Items", icon: ReceiptText },
      { featureKey: "schemes", featureName: "Schemes", icon: Award, hidden: true },
      { featureKey: "creditDebitNotes", featureName: "Credit / Debit Notes", icon: ReceiptText },
      { featureKey: "paymentReceipts", featureName: "Payment Receipts", icon: ReceiptText },
      { featureKey: "cashDeposits", featureName: "Cash Deposits", icon: ReceiptText },
    ],
  },
  {
    groupKey: "inventory",
    groupName: "Inventory",
    icon: Warehouse,
    items: [
      { featureKey: "stockBalances", featureName: "Stock Balances", icon: Boxes },
      { featureKey: "stockLedger", featureName: "Stock Ledger", icon: FileStack },
      { featureKey: "stockTransfers", featureName: "Stock Transfer (In / Out)", icon: ArrowLeftRight },
      { featureKey: "stockJournalReport", featureName: "Stock Journal", icon: BookOpenText },
      { featureKey: "stockLowReport", featureName: "Stock Low", icon: Boxes },
      { featureKey: "stockExcessReport", featureName: "Stock Excess", icon: Boxes },
      { featureKey: "closingStockHistory", featureName: "Daily Closing Stock", icon: History },
      { featureKey: "warehouses", featureName: "Warehouses", icon: Warehouse },
    ],
  },
  {
    groupKey: "delivery",
    groupName: "Delivery",
    icon: Truck,
    items: [
      { featureKey: "loadingSheets", featureName: "Loading Sheets", icon: Truck, hidden: true },
    ],
  },
  receivablesMenuGroup,
  {
    groupKey: "accounting",
    groupName: "Accounting",
    icon: Calculator,
    items: [
      { featureKey: "ledgers", featureName: "Ledgers", icon: BookOpenText },
      { featureKey: "accountingVouchers", featureName: "Vouchers / Day Book", icon: ReceiptText },
      { featureKey: "accountingSettings", featureName: "Accounting Settings", icon: Settings },
    ],
  },
  {
    groupKey: "accountingReports",
    groupName: "Accounting Reports",
    icon: BarChart3,
    items: [
      { featureKey: "financialSummaryReport", featureName: "Financial Summary", icon: Gauge },
      { featureKey: "profitLossReport", featureName: "Profit & Loss", icon: PieChart },
      { featureKey: "expenseReport", featureName: "Expense Report", icon: Wallet },
      { featureKey: "balanceSheetReport", featureName: "Balance Sheet", icon: Scale },
      { featureKey: "ledgerWiseTotalsReport", featureName: "Ledger-wise Totals (Trial Balance)", icon: BookOpenText },
      { featureKey: "ledgerVouchersReport", featureName: "Ledger Vouchers", icon: BookOpenText },
      { featureKey: "cashBankReport", featureName: "Cash & Bank Balances", icon: Wallet },
      { featureKey: "cashFlowReport", featureName: "Cash Flow (Inflow / Outflow)", icon: ArrowLeftRight },
      { featureKey: "workingCapitalReport", featureName: "Current Assets & Liabilities", icon: Banknote },
      { featureKey: "ratioAnalysisReport", featureName: "Ratio Analysis", icon: Percent },
      { featureKey: "stockValuationReport", featureName: "Stock Valuation", icon: Boxes },
      { featureKey: "receivablesReport", featureName: "Receivables & Overdue", icon: Receipt },
      { featureKey: "billWisePaymentsReport", featureName: "Bill Wise Payment Tracker", icon: Receipt },
      { featureKey: "outstandingBillsReport", featureName: "Outstanding / Pending Bills", icon: Receipt },
      { featureKey: "payablesReport", featureName: "Payables & Overdue", icon: Receipt },
      { featureKey: "stockSummaryReport", featureName: "Stock Summary", icon: Boxes },
      { featureKey: "closingStockReport", featureName: "Closing Stock", icon: Boxes },
      { featureKey: "categoryClosingStockReport", featureName: "Category Wise Closing Stock", icon: Boxes },
      { featureKey: "stockMovementReport", featureName: "Stock Movement", icon: FileStack },
      { featureKey: "salesRegisterReport", featureName: "Sales Register", icon: BookOpenText },
      { featureKey: "purchaseRegisterReport", featureName: "Purchase Register", icon: BookOpenText },
      { featureKey: "gstReport", featureName: "GST Reports", icon: LandPlot },
      { featureKey: "itemWiseSalesReport", featureName: "Product Wise Sales", icon: Package },
      { featureKey: "productWiseReturnsReport", featureName: "Product Wise Return / Cancel", icon: Package },
      { featureKey: "schemeDiscountReport", featureName: "Scheme Discount", icon: Percent },
      { featureKey: "creditNotesReport", featureName: "Credit Notes", icon: Receipt },
      { featureKey: "customerWiseSalesReport", featureName: "Customer-wise Sales", icon: Contact },
      { featureKey: "salesmanWiseSalesReport", featureName: "Salesman-wise Sales", icon: Users },
      { featureKey: "ledgerStatementReport", featureName: "Customer Ledger Statement", icon: BookOpenText },
      { featureKey: "cashInHandReport", featureName: "Cash in Hand", icon: Receipt },
    ],
  },
  {
    groupKey: "admin",
    groupName: "Admin",
    icon: Shield,
    items: [
      { featureKey: "profile", featureName: "Company Profile", icon: Settings },
      { featureKey: "users", featureName: "Users", icon: UserCog },
      // Distributors page is retired: a distributor account is created from the Sign up link on the login page.
      // { featureKey: "distributors", featureName: "Distributors", icon: Building2 },
      { featureKey: "roles", featureName: "Roles & Permissions", icon: Shield },
      { featureKey: "importColumnMapping", featureName: "Import Column Mapping", icon: FileStack },
      { featureKey: "importHistory", featureName: "Import Sync History", icon: CloudUpload },
      { featureKey: "distributorLinks", featureName: "Distributor Links (Super Admin)", icon: Building2 },
      { featureKey: "voucherTypes", featureName: "Voucher Types", icon: ReceiptText },
      { featureKey: "receivableSettings", featureName: "Settings", icon: Settings2 },
    ],
  },
];

/**
 * The menu as shown: items marked `hidden` are left out (their pages still exist and can be brought back by removing the
 * flag), and so is a group left with nothing in it.
 */
export const visibleMenuGroups = menuGroups
  .map((group) => ({ ...group, items: group.items.filter((item) => !item.hidden) }))
  .filter((group) => group.items.length > 0);

const Sidebar = ({ activePage, setActivePage }) => {
  const activeGroupKey = visibleMenuGroups.find((group) =>
    group.items.some((item) => item.featureKey === activePage)
  )?.groupKey;

  const [openGroups, setOpenGroups] = useState(() => new Set([activeGroupKey || visibleMenuGroups[0].groupKey]));

  const toggleGroup = (groupKey) => {
    setOpenGroups((prev) => {
      const next = new Set(prev);
      if (next.has(groupKey)) next.delete(groupKey);
      else next.add(groupKey);
      return next;
    });
  };

  return (
    <aside className="app-sidebar fixed h-screen w-64 p-4 flex flex-col">
      <div className="sidebar-brand">
        <div className="sidebar-brand-mark">TT</div>
        <div>
          <div className="sidebar-brand-text">Turbo Trade</div>
          <div className="sidebar-brand-subtext">Admin Console</div>
        </div>
      </div>
      <nav className="flex flex-col space-y-1 flex-1 min-h-0 overflow-y-auto pr-1 sidebar-scroll">
        {topLevelItems.map((item) => {
          const ItemIcon = item.icon;
          const isActive = activePage === item.featureKey;
          return (
            <button
              key={item.featureKey}
              type="button"
              onClick={() => setActivePage(item.featureKey)}
              className={`sidebar-group-header${isActive ? " active" : ""}`}
            >
              <span className="flex items-center gap-3">
                <span className="sidebar-group-icon">
                  <ItemIcon size={16} />
                </span>
                <span>{item.featureName}</span>
              </span>
            </button>
          );
        })}

        <div style={{ height: "1px", background: "var(--color-border)", margin: "8px 4px" }} />

        {visibleMenuGroups.map((group) => {
          const GroupIcon = group.icon;
          const isOpen = openGroups.has(group.groupKey);
          const isGroupActive = group.items.some((item) => item.featureKey === activePage);

          return (
            <div className="sidebar-group" key={group.groupKey}>
              <button
                type="button"
                onClick={() => toggleGroup(group.groupKey)}
                className={`sidebar-group-header${isGroupActive ? " active" : ""}`}
              >
                <span className="flex items-center gap-3">
                  <span className="sidebar-group-icon">
                    <GroupIcon size={16} />
                  </span>
                  <span>{group.groupName}</span>
                </span>
                <ChevronDown
                  size={15}
                  style={{
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                    color: "var(--color-text-faint)",
                    flexShrink: 0,
                  }}
                />
              </button>

              {isOpen ? (
                <div className="sidebar-group-items">
                  {group.items.map((item) => {
                    const ItemIcon = item.icon;
                    const isActive = activePage === item.featureKey;
                    return (
                      <button
                        key={item.featureKey}
                        type="button"
                        onClick={() => setActivePage(item.featureKey)}
                        className={`sidebar-subitem${isActive ? " active" : ""}`}
                      >
                        <ItemIcon size={14} />
                        <span>{item.featureName}</span>
                      </button>
                    );
                  })}
                </div>
              ) : null}
            </div>
          );
        })}
      </nav>
    </aside>
  );
};

export default Sidebar;
